import TYPES from './types';

export default [
  {
    type: TYPES.Row,
    children: [{ key: 'sLibelle', className: 'resource-title' }],
  },
];
